export const urls = {
    // API : "https://www.rentit.qwpcorp.com/api/"
    // API : "http://127.0.0.1:8000/api/"
    // API : "https://protected-dawn-02995.herokuapp.com/"
    API : "https://www.mik.qwpcorp.com/public/api/"
}